import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { SubscriptionAddress, ISubscriptionAddressStoreProps } from './subscription_address';
import { IState } from '../../store';
import { setVisible, fetchCreateSubscriptionRequest } from '../../store/popups/subscription_address';
import { ICreateSubscriptionRequest } from '../../repositories/monolith-python/v1/create-subscription';

export function mapStateToProps(state: IState): ISubscriptionAddressStoreProps {
  return {
    isOpen: state.subscriptionAddress.isOpen,
    isLoad: state.subscriptionAddress.isLoad,
    isSubscribe: state.subscriptionAddress.isSubscribe,
    globalError: state.subscriptionAddress.globalError,
    offer: state.offerData.offer,
    user: state.offerData.user,
    pushSubscribed: state.pushSubscribed,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<IState>) {
  return {
    setVisible: (isOpen: boolean) => dispatch(setVisible(isOpen)),
    fetchCreateSubscription: (parameters: ICreateSubscriptionRequest) => {
      return dispatch(fetchCreateSubscriptionRequest(parameters));
    },
  };
}

export const SubscriptionAddressContainer = connect(mapStateToProps, mapDispatchToProps)(SubscriptionAddress);
